
import FormInput from '@/mixins/FormInput.js'

export default {
  mixins: [FormInput],
  data () {
    return {
      errors: [],
      password: '',
      resetToken: '',
      loading: false,
      dialog: false
    }
  },
  computed: {
    isRecoveryRoute () {
      return this.$route.query.type === 'recovery'
    }
  },
  watch: {
    isRecoveryRoute: {
      handler (value) {
        this.dialog = value
      },
      immediate: true
    },
    password () {
      if (this.errors.length) {
        this.errors = []
      }
    }
  },
  methods: {
    async resetPassword () {
      this.loading = true

      try {
        await this.$djangoApi.post('/api-internes/users/password', {
          password: this.password
        })
      } catch (error) {
        this.errors = error.response?.data?.errors ?? []
        this.loading = false

        return
      }

      this.loading = false
      this.dialog = false
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params
      })
    },
    async signOut () {
      const { error } = await this.$supabase.auth.signOut()

      if (error) {
        return
      }

      this.$router.push('/')
    }
  }
}
